import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import "assets/css/Plugins.css";
import "./assets/css/App.css";
import "@aws-amplify/ui-react/styles.css";
import "./styles/pdf.css";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import { Authenticator } from "@aws-amplify/ui-react";
import { DealProvider, useDealData } from "contexts/DealContext";
import { PortfolioProvider } from "contexts/PortfolioContext";
import { ViewModeProvider } from "contexts/ViewModeContext";
import { AsanaProvider } from "contexts/AsanaContext";
import { TabProvider } from "contexts/TabContext";
import { getCurrentUser } from "aws-amplify/auth";
import LoadingScreen from "components/LoadingScreen";

Amplify.configure(awsconfig);

// AppContent component that uses the DealContext
const AppContent = ({ user, themeApp, setThemeApp, mini, setMini }) => {
  const { isLoading, consolidatedData } = useDealData();

  // Only show loading screen during initial data loading
  // This ensures we don't show the loading screen when switching between deals
  if (isLoading && !consolidatedData) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={
            <Routes>
              <Route path="auth/*" element={<Navigate to="/deals" replace />} />
              {/* Deal Routes */}
              <Route path="/deals/:dealName/financial-model" element={
                <AdminLayout pageToShow="FinancialModel" />
              } />
              <Route path="/deals/:dealName/finance-charts/:chartType" element={
                <AdminLayout pageToShow="FinanceChart" />
              } />
              <Route path="/deals/:dealName/competition-charts/:chartType" element={
                <AdminLayout pageToShow="CompetitionChart" />
              } />
              <Route path="/deals/:dealName/*" element={
                <AdminLayout />
              } />
              <Route path="/deals/*" element={
                <AdminLayout />
              } />

              {/* Portfolio Routes */}
              <Route path="/portfolio/:portfolioName/:facilityName/financial-model" element={
                <AdminLayout pageToShow="FinancialModel" />
              } />
              <Route path="/portfolio/:portfolioName/:facilityName/finance-charts/:chartType" element={
                <AdminLayout pageToShow="FinanceChart" />
              } />
              <Route path="/portfolio/:portfolioName/:facilityName/competition-charts/:chartType" element={
                <AdminLayout pageToShow="CompetitionChart" />
              } />
              <Route path="/portfolio/:portfolioName/financial-model" element={
                <AdminLayout pageToShow="FinancialModel" />
              } />
              <Route path="/portfolio/:portfolioName/finance-charts/:chartType" element={
                <AdminLayout pageToShow="FinanceChart" />
              } />
              <Route path="/portfolio/:portfolioName/competition-charts/:chartType" element={
                <AdminLayout pageToShow="CompetitionChart" />
              } />
              <Route path="/portfolio/:portfolioName/:facilityName/*" element={
                <AdminLayout pageToShow="PortfolioOverview" />
              } />
              <Route path="/portfolio/:portfolioName/*" element={
                <AdminLayout pageToShow="PortfolioOverview" />
              } />
              <Route path="/portfolio/*" element={
                <AdminLayout pageToShow="PortfolioOverview" />
              } />

              {/* Other Routes */}
              <Route path="/manage-groups" element={
                <AdminLayout />
              } />
              <Route path="/deal-tracker" element={
                <AdminLayout
                  pageToShow="DealTracker"
                />
              } />
              <Route path="/photos" element={
                <AdminLayout />
              } />
              <Route path="/status" element={
                <AdminLayout pageToShow="DealTracker" />
              } />
              <Route path="/financial-model" element={
                <AdminLayout pageToShow="FinancialModel" />
              } />
              <Route path="/finance-charts/:chartType" element={
                <AdminLayout pageToShow="FinanceChart" />
              } />
              <Route path="/competition-charts/:chartType" element={
                <AdminLayout pageToShow="CompetitionChart" />
              } />
              <Route path="/" element={<Navigate to="/deals" replace />} />
            </Routes>
          }
        />
      </Routes>
    </>
  );
};

export default function App() {
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    checkAuthentication();
  }, []);

  async function checkAuthentication() {
    try {
      await getCurrentUser();
      setAuthChecked(true);
    } catch (error) {
      console.error('Error fetching user:', error);
      setAuthChecked(true);
    }
  }

  const formFields = {
    signUp: {
      given_name: {
        placeholder: "First Name",
        label: "First Name",
        isRequired: true,
        order: 3
      },
      family_name: {
        placeholder: "Last Name",
        label: "Last Name",
        isRequired: true,
        order: 4,
      }
    },
    forceNewPassword: {
      given_name: {
        placeholder: "First Name",
        label: "First Name",
        isRequired: true,
        order: 1,
      },
      family_name: {
        placeholder: "Last Name",
        label: "Last Name",
        isRequired: true,
        order: 2,
      }
    }
  };

  if (!authChecked) {
    return <LoadingScreen message="Authenticating..." />;
  }

  return (
    <div className="w-full absolute top-[90px]">
      <Authenticator formFields={formFields} hideSignUp={true}>
        {({ user }) => (
          user ? (
            <ViewModeProvider>
              <DealProvider>
                <PortfolioProvider>
                  <AsanaProvider>
                    <TabProvider>
                      <AppContent
                        user={user}
                      />
                    </TabProvider>
                  </AsanaProvider>
                </PortfolioProvider>
              </DealProvider>
            </ViewModeProvider>
          ) : (
            <Routes>
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="*" element={<Navigate to="/auth" replace />} />
            </Routes>
          )
        )}
      </Authenticator>
    </div>
  );
}